<template>
  <div v-if="type === ''" class="container">
    <div class="row justify-content-center p-2 p-md-5">
      <div class="col-lg-10 col-md-10 p-4">
        <h2>{{ $t("Create an Account as...") }}</h2>
          <div class="row p-4">
            <div class="col-md-6">
              <div style="  margin: 36px;">
                <button class="btn " @click="$router.push('register-healthcare-professional')"><span>{{ $t("Healthcare professional") }}</span></button>
              <div class="pt-2">
                {{ $t("For licensed nurses, doctors, or physiotherapists who want to offer care through the Heed platform.") }}
              </div>
            </div>
            </div>
            <div class="col-md-6">
              <div style="  margin: 36px;">
                <button class="btn" @click="$router.push('register-client')"> {{ $t("Client Seeking Care") }}</button>
              <div class="pt-2">
                {{ $t("For individuals or family members who need professional healthcare services at home.") }}
              </div>
              </div>
            </div>
</div>
      </div>
    </div>
  </div>
<!--  <client-registration v-if="type === 'client'"></client-registration>-->
<!--  <employee-registration v-if="type === 'employee'"></employee-registration>-->
</template>
<script>
import ClientRegistration from "@/views/Clients/ClientRegistration.vue"
import EmployeeRegistration from "@/views/Employee/EmployeeRegistration.vue"

export default {
  name: "Register",
  // components: {EmployeeRegistration, ClientRegistration},
  data() {
    return {
      type: ""
    }
  }
}
</script>

<style scoped>
button {
  border-radius: 4px;
  background-color: #e50044;
  border: none;
  color: #fff;
  text-align: center;
  font-size: 22px;
  padding: 16px;
  width: -webkit-fill-available;
  transition: all 0.5s;
  cursor: pointer;
  box-shadow: 0 10px 20px -8px rgba(0, 0, 0,.7);
}

button{
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

button:after {
  content: '»';
  position: absolute;
  opacity: 0;
  right: -20px;
  transition: 0.5s;
}

button:hover{
  padding-right: 24px;
  padding-left:8px;
}

button:hover:after {
  opacity: 1;
  right: 10px;
}
</style>